<app-closures-filters (onFilter)="onFilter($event)" [defaultFilters]="defaultFilters">
</app-closures-filters>

<div class="table-container">
    <table mat-table matSort [dataSource]="closures" multiTemplateDataRows matSortDisableClear matSortDirection="asc">
        <ng-container matColumnDef="closure_date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Giorno di chiusura </th>
            <td mat-cell *matCellDef="let element"> {{ element.closureDate | date:'dd/MM/yyyy'}} </td>
        </ng-container>

        <!-- <ng-container matColumnDef="tenant">
          <th mat-header-cell *matHeaderCellDef> Punto Vendita </th>
          <td mat-cell *matCellDef="let element">
            {{ getTenantName(element) }}
            <ng-template #loading>
              <p>Caricamento...</p>
            </ng-template>
          </td>
        </ng-container>         -->

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="add-icon-container">
              <button mat-mini-fab *ngIf="canAdd" matTooltip="Nuovo giorno di chiusura"
                (click)="$event.stopPropagation(); addClosure()" color="primary">
                <mat-icon>add</mat-icon>
              </button>
            </th>
            <td mat-cell *matCellDef="let row" class="modify-icon-container">
              <ng-container>
                <button mat-icon-button (click)="$event.stopPropagation(); editClosure(row)">
                  <mat-icon matTooltip="Modifica">create</mat-icon>
                </button>
              </ng-container>
      
             
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="editClosure(row)"></tr>
    </table>

  <mat-paginator     [pageSizeOptions]="pageSizeOptions"
  [pageSize]="pageSizeOptions[0]"
  [length]="total | async">
  </mat-paginator>  

</div>